"use client";

import store from "@/redux/store.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReCaptchaProvider } from "next-recaptcha-v3";
import { useState } from "react";
import { Provider } from "react-redux";

export default function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <ReCaptchaProvider
      reCaptchaKey={
        process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ||
        "6LdlRHYrAAAAADNOdPypNcWHeYobw2anE28X4ONL"
      }
    >
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          {children}
        </QueryClientProvider>
      </Provider>
    </ReCaptchaProvider>
  );
}
